import { render } from "./ShowDeviceData.vue?vue&type=template&id=8d203770&scoped=true"
import script from "./ShowDeviceData.vue?vue&type=script&lang=js"
export * from "./ShowDeviceData.vue?vue&type=script&lang=js"

import "./ShowDeviceData.vue?vue&type=style&index=0&id=8d203770&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-8d203770"

export default script